// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteServerGroupMutationVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
}>;

export type DeleteServerGroupMutation = {
  __typename?: "Mutation";
  deleteServerGroup: {
    __typename?: "DeleteServerGroupPayload";
    organization: { __typename?: "Organization"; id: string };
  };
};

export const DeleteServerGroupDocument = gql`
  mutation DeleteServerGroup($serverGroupId: ID!) {
    deleteServerGroup(serverGroupId: $serverGroupId) {
      organization {
        id
      }
    }
  }
`;
export type DeleteServerGroupMutationFn = Apollo.MutationFunction<
  DeleteServerGroupMutation,
  DeleteServerGroupMutationVariables
>;

/**
 * __useDeleteServerGroupMutation__
 *
 * To run a mutation, you first call `useDeleteServerGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServerGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServerGroupMutation, { data, loading, error }] = useDeleteServerGroupMutation({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *   },
 * });
 */
export function useDeleteServerGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteServerGroupMutation,
    DeleteServerGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteServerGroupMutation,
    DeleteServerGroupMutationVariables
  >(DeleteServerGroupDocument, options);
}
export type DeleteServerGroupMutationHookResult = ReturnType<
  typeof useDeleteServerGroupMutation
>;
export type DeleteServerGroupMutationResult =
  Apollo.MutationResult<DeleteServerGroupMutation>;
export type DeleteServerGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteServerGroupMutation,
  DeleteServerGroupMutationVariables
>;
